import { TemplateRef } from "@angular/core";

export interface QuestionConfig {
  title?: string;
  content?: string | TemplateRef<any>;
  question: string;
  class?: string;
  params?: object;
  dismiss?:
    | boolean
    | {
        backdrop?: boolean;
        escape?: boolean;
      };
  showCancelAction?: boolean;
}
